import { Translation } from '@ps/web-shared-components';
import type { FunctionComponent } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';

import Link from '@swf/components/Link/Link';
import type { RootState } from '@swf/core/store';
import type { Values } from '@swf/core/types/i18n';
import type { MarketId } from '@swf/generated/types/api/sports';
import { Icon } from '@swf/sports/components';

import { useSportsNextRacesWidget } from '../model';

import { TXTWCL_View_Full_Race_Card } from './ViewFullRaceCard.messages.json';
import styles from './ViewFullRaceCard.scss';

const ViewFullRaceCard: FunctionComponent<{ marketId: MarketId }> = ({ marketId }) => {
  const { widgetSelect } = useSportsNextRacesWidget();

  const raceCardLinkValues = useSelector((state: RootState) =>
    widgetSelect.raceCardLinkValues(state, marketId)
  );

  return (
    <Link
      className={styles.viewFullLink}
      alias="sportsAnimalRacingRace"
      values={raceCardLinkValues as unknown as Values}
    >
      <Translation {...TXTWCL_View_Full_Race_Card} />
      <Icon name="chevron-medium-right" size="xl" />
    </Link>
  );
};

export default ViewFullRaceCard;
